import { getOralExamQuestionTitle } from '@/common/components/OralExamQuestionText';

function sameLabel(left: string | undefined, right: string | undefined): boolean {
  const a = left?.trim();
  const b = right?.trim();
  if (!a || !b) return false;
  return a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0;
}

/** True when the question's own title is the topic already shown as the heading. */
export function questionTitleRepeatsTopic(
  question: string | undefined,
  topic: string | undefined,
): boolean {
  return sameLabel(getOralExamQuestionTitle(question ?? ''), topic);
}

/** True when a concept chip would repeat the topic already shown above the card. */
export function conceptRepeatsTopic(
  concept: string | undefined,
  topic: string | undefined,
): boolean {
  return sameLabel(concept, topic);
}
